export default __webpack_public_path__ + "static/media/regulatory--sidewalk-closed--g1.e4dd968e.png";